<template>
  <generic-modal :title="$t('payment register')" ref="generic_modal">
    <form>
      <div class="title is-5">{{ member.name }}</div>
      <div
        class="columns"
        v-for="(payment_method, pidx) in meta.payment_methods"
        :key="pidx"
      >
        <div class="column">
          <div class="field">
            <label class="label">{{ payment_method.name }}</label>
            <div class="control has-icons-left">
              <input
                class="input is-medium"
                type="text"
                v-model="meta.payment_methods[pidx].amount"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-money"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field" v-show="payment_method.ask_for_document_number">
            <label class="label">{{ $t("voucher/transaction number") }}</label>
            <div class="control has-icons-left">
              <input
                class="input is-medium"
                type="text"
                v-model="meta.payment_methods[pidx].document_number"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-file"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <p class="buttons is-pulled-right mt-2">
        <a class="button is-static is-size-5 has-text-warning">
          {{ format_currency(total_payment) }} <br />
          {{ $t("total payment") }}
        </a>
      </p>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_date,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "PaymentModal",
  components: { GenericModal },
  data() {
    return {
      member: {},
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.total_payment || isNaN(v.total_payment);
    },
    total_payment() {
      let v = this;
      if (v.meta.payment_methods)
        return v.meta.payment_methods.reduce((acc, pm) => {
          if (pm.amount) return acc + Number(pm.amount);
          else return acc;
        }, 0);
      else return 0;
    },
  },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  methods: {
    format_currency,
    format_date,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(member) {
      let v = this;
      v.set_initial_state();
      v.member = member;
      v.meta.gym_member_id = member.gym_member_id;
      v.meta.payment_methods = JSON.parse(
        JSON.stringify(v.module_settings.payment_methods)
      );
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let payment_methods = v.meta.payment_methods
        .filter((i) => i.amount)
        .map((pm) => {
          return {
            payment_method: pm.name,
            amount: pm.amount,
            document_number: pm.document_number,
          };
        });
      put("/gym_member/payment", {
        gym_member_id: v.meta.gym_member_id,
        payment_methods,
      })
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.member = {};
      v.meta = {
        gym_member_id: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
